/* Zora & Zack: Scroll-Zoom auf den Schubladenstock und Hörproben. Läuft nur einmal pro Seite. */
(function () {
  if (window.zzZoraZack) return;
  window.zzZoraZack = true;

  var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var scenes = [];
  var raf = 0;

  function collect() {
    scenes = Array.prototype.slice.call(document.querySelectorAll('[data-zz-scrolly]')).map(function (sec) {
      return { sec: sec, stage: sec.querySelector('[data-zz-stage]') };
    });
    update();
  }

  function ease(z) {
    return z < 0.5 ? 2 * z * z : 1 - Math.pow(-2 * z + 2, 2) / 2;
  }

  function update() {
    raf = 0;
    var reduce = !!(motion && motion.matches);
    scenes.forEach(function (scene) {
      var stage = scene.stage;
      if (!stage || !scene.sec.isConnected) return;
      if (reduce) {
        stage.style.setProperty('--p', '0');
        return;
      }
      var rect = scene.sec.getBoundingClientRect();
      var run = rect.height - stage.offsetHeight;
      // Die Bühne klebt auf dem Handy nicht ganz oben, sondern in der Bildschirmmitte.
      var top = parseFloat(getComputedStyle(stage).top) || 0;
      var t = run > 0 ? Math.min(1, Math.max(0, (top - rect.top) / run)) : 0;
      // Erste 10 % ruhig, dann über 70 % zoomen, Rest gezoomt halten.
      var z = Math.min(1, Math.max(0, (t - 0.1) / 0.7));
      var p = ease(z);
      stage.style.setProperty('--p', p.toFixed(4));
      stage.classList.toggle('is-zoomed', p > 0.2);
    });
  }

  // Tipp auf den Hinweis: weich bis zu den zwei geöffneten Schubladen scrollen.
  function skipTo(scene) {
    var stage = scene.stage;
    var rect = scene.sec.getBoundingClientRect();
    var run = rect.height - stage.offsetHeight;
    var top = parseFloat(getComputedStyle(stage).top) || 0;
    window.scrollTo({ top: window.pageYOffset + rect.top - top + run * 0.82, behavior: 'smooth' });
  }

  function tick() {
    if (!raf) raf = requestAnimationFrame(update);
  }

  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', tick);
  if (motion) {
    if (motion.addEventListener) motion.addEventListener('change', tick);
    else if (motion.addListener) motion.addListener(tick);
  }

  // Theme-Editor: Section wird neu geladen oder entfernt.
  document.addEventListener('shopify:section:load', collect);
  document.addEventListener('shopify:section:unload', function () {
    pauseAll();
    setTimeout(collect, 0);
  });

  // Hörproben
  function buttonFor(audio) {
    return document.querySelector('[data-zz-audio="' + audio.id + '"]');
  }

  function setState(audio, playing) {
    var btn = buttonFor(audio);
    if (!btn) return;
    btn.classList.toggle('is-playing', playing);
    btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
    var label = btn.querySelector('[data-zz-audio-label]');
    if (label) label.textContent = playing ? btn.dataset.labelPause : btn.dataset.labelPlay;
  }

  function pauseAll(except) {
    document.querySelectorAll('.zz audio').forEach(function (audio) {
      if (audio !== except && !audio.paused) audio.pause();
    });
  }

  document.addEventListener('click', function (evt) {
    var skip = evt.target.closest && evt.target.closest('[data-zz-skip]');
    if (skip) {
      var sec = skip.closest('[data-zz-scrolly]');
      scenes.forEach(function (scene) {
        if (scene.sec === sec && scene.stage) skipTo(scene);
      });
      return;
    }
    var btn = evt.target.closest && evt.target.closest('[data-zz-audio]');
    if (!btn) return;
    var audio = document.getElementById(btn.dataset.zzAudio);
    if (!audio) return;
    if (audio.paused) {
      pauseAll(audio);
      var played = audio.play();
      if (played && played.catch) {
        played.catch(function () {
          setState(audio, false);
        });
      }
    } else {
      audio.pause();
    }
  });

  ['play', 'pause', 'ended'].forEach(function (type) {
    document.addEventListener(
      type,
      function (evt) {
        var audio = evt.target;
        if (!audio || audio.tagName !== 'AUDIO' || !audio.closest('.zz')) return;
        setState(audio, type === 'play');
        if (type === 'ended') audio.currentTime = 0;
      },
      true
    );
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collect);
  else collect();
})();
